export const optionalDeliverables = [
  { id: 1, name: '30-second campaign cutdown', price: 650, enabled: true },
  { id: 2, name: '15-second campaign cutdown', price: 450, enabled: true },
  { id: 3, name: 'Vertical 9:16 social version', price: 350, enabled: true },
  { id: 4, name: '3 × short social media video edits', price: 900, enabled: true },
  { id: 5, name: 'Additional interview / testimonial edit', price: 750, enabled: true },
  { id: 6, name: 'Still-frame image package', price: 250, enabled: true },
  { id: 7, name: 'Additional captioned / subtitled version', price: 200, enabled: true },
  { id: 8, name: 'Additional motion graphics package', price: 750, enabled: true }
];

export const quotes = [
  {
    reference: 'AAF-1042',
    client: 'Aggreko',
    project: 'Melbourne Data Centre Case Study',
    base: '$4,900',
    accepted: '—',
    status: 'Sent',
    created: '14 Jun 2025'
  },
  {
    reference: 'AAF-1041',
    client: 'The Hutchins School',
    project: 'School Promotional Film',
    base: '$7,250',
    accepted: '$8,150',
    status: 'Accepted',
    created: '10 Jun 2025'
  },
  {
    reference: 'AAF-1040',
    client: 'Department of Education Tasmania',
    project: 'Staff Recruitment Video',
    base: '$5,600',
    accepted: '—',
    status: 'Draft',
    created: '06 Jun 2025'
  }
];

export const formatPrice = (amount) =>
  new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0
  }).format(amount);